<template>
  <div>
    <actions-dropdown @action-selected="actionSelected" />
  </div>
</template>

<script setup>
import ActionsDropdown from './actions-dropdown.vue'
import {
  ARCHIVE_WORKFLOW_ACTION,
  CREATE_REMARK_ACTION,
  DOWNLOAD_AS_EXCEL_ACTION,
} from './constants'

const emit = defineEmits(['downloadAsExcel'])

const actionSelected = ({ action, payload }) => {
  if (action === CREATE_REMARK_ACTION) {
    window.modalCitizen.openModalPortal(
      'insights-actions-create-remark-modal',
      payload
    )
  }

  if (action === DOWNLOAD_AS_EXCEL_ACTION) {
    emit(DOWNLOAD_AS_EXCEL_ACTION)
  }

  if (action === ARCHIVE_WORKFLOW_ACTION) {
    window.modalCitizen.openModalPortal(
      'insights-actions-archive-workflow-modal',
      payload
    )
  }
}
</script>
